import { Inject, Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {ICrearFacturaExterna, IFacturaExternaTmp} from "../../shared/interfaces/liquidacion";
import { API_URL } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class FacturaExternaTmpService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private http:HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/factura-externas-tmp`;
  }

  crear(body:ICrearFacturaExterna):Observable<number>{
    const url= `${this.baseUrl}/crear`
    return this.http.post<number>(url,body)
  }

  getFactura(solicitud:number):Observable<number>{
    const url = `${this.baseUrl}/solicitud/${solicitud}`;
    return this.http.get<number>(url);
  }

  getDetalleBySolicitud(solicitud:number):Observable<IFacturaExternaTmp>{
    const url = `${this.baseUrl}/detalle/${solicitud}`;
    return this.http.get<IFacturaExternaTmp>(url);
  }

  isVigente(solicitud: number): Observable<boolean> {
    const url = `${this.baseUrl}/vigente/${solicitud}`;
    return this.http.get<boolean>(url);
  }

}
